"use client";

import { useTrackModal, Track } from "./top-5-tracks-list";
import { motion } from "framer-motion";

interface Top5TrackButtonProps {
  track: Track;
  index: number;
}

export default function Top5TrackButton({
  track,
  index,
}: Top5TrackButtonProps) {
  const { openModal, getLayoutId } = useTrackModal();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openModal(track);
  };

  return (
    <motion.button
      layoutId={getLayoutId(track.name, "button")}
      onClick={handleClick}
      className="flex items-center flex-shrink-0"
    >
      <div
        aria-label={`Listen to ${track.name}`}
        className="text-xxs text-inverse font-semibold px-2 w-20 justify-center h-6 rounded flex-shrink-0 bg-ink flex items-center hover:bg-theme-neon hover:text-on-accent transition-colors"
      >
        <span className="text-[0.65rem] font-bold">Listen</span>
      </div>
    </motion.button>
  );
}
